(function () {
  const initScrollTop = () => {
    const btnScrollTop = document.querySelector('.scroll-top__block');
    if (!btnScrollTop) return;

    if (btnScrollTop.dataset.scrollTopBound === 'true') return;
    btnScrollTop.dataset.scrollTopBound = 'true';

    const thresholdPx = Math.max(1, parseInt(btnScrollTop.dataset.showAfter || '500', 10));

    const updateVisibility = () => {
      if (scrollY >= thresholdPx) {
        btnScrollTop.classList.add('show');
      } else {
        btnScrollTop.classList.remove('show');
      }
    };

    window.addEventListener('scroll', updateVisibility, { passive: true });
    updateVisibility();

    btnScrollTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  };

  initScrollTop();

  document.addEventListener('shopify:section:load', function () {
    initScrollTop();
  });
})();
